import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { API_BASE_URL } from '../service-proxies';
import { VerifyQRForAttendanceDto } from 'app/main/qr-attendance/qr-attendance.component';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QrAttendanceService {
  private http: HttpClient;
  private baseUrl: string;

   constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
      this.http = http;
      this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmployeeBasicDetailsForQrAttendance(id: string, ipAddress: string): Observable<any> {
      const url = `${this.baseUrl}/api/ClockInOut/getEmployeeBasicDetailsForQrAttendance?cipherText=${id}&ipAddress=${ipAddress}`;
      return this.http.get(url).pipe(
        catchError((error) => {
          console.error('API Error:', error);
          throw error;
        })
      );
    }

    verifyQRForAttendance(request: VerifyQRForAttendanceDto): Observable<any> {
      const url = `${this.baseUrl}/api/ClockInOut/verifyQRForAttendance`;
      return this.http.post(url, request).pipe(
        catchError((error) => {
          console.error('API Error:', error);
          throw error;
        })
      );
    }

    getIPAddress(): Observable<any> {
      return this.http.get('https://checkip.amazonaws.com/', { responseType: 'text' });
    }
}
